export default [
  'str',
  'ltc',
  'blk',
  'dash',
  'doge',
  'eth',
  'ftc',
  'mint',
  'nbt',
  'nvc',
  'pot',
  'ppc',
  'uno',
  'btc',
  'eth',
  'dsh',
  'etc',
  'nmc',
  'maid',
  'usdt',
  'vtc',
  'amp',
  'zec',
  'bft',
  'rif',
  'dala',
  'drk',
  'flp',
  'mad',
  'nec',
  'ngc',
  'pxs',
  'sense',
  'shp',
  'zeph',
  'wib',
  'rndr',
  'bax',
  'bxa',
  'leo',
  'ldc',
  'bfusd',
  'tusd',
];
